import api from '../../boot/openapi';
import ApiError from './error';

const OrderService = {
  async post(data) {
    if (!data.provider) {
      data.provider = process.env.PROVIDER;
    }

    const client = await api.getClient();
    try {
      return await client.purchaseProduct(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async initPayment(data) {
    const client = await api.getClient();
    try {
      return await client.initPayment(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async processPayment3dSecure(data) {
    const client = await api.getClient();
    try {
      return await client.processPayment3dSecure(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async finalizePayment(data) {
    const client = await api.getClient();
    try {
      return await client.finalizePayment(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default OrderService;
